module.exports = __webpack_public_path__ + "img/info.28e638e9.svg";